exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bt_green a[data-v-7ec6804a]{width:320px}.text--small[data-v-7ec6804a]{font-size:14px}@media screen and (max-width:800px){.mobile_br[data-v-7ec6804a]{display:block}}", ""]);

// exports
